function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export { getRandomIntInclusive };



//////////////////
// WEBPACK FOOTER
// ./lib/util.js
// module id = 5
// module chunks = 0